import React, { ChangeEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Pagination, { PaginationRenderItemParams } from '@material-ui/lab/Pagination'

import { datatableActions, datatableSelectors } from '@/react-components/datatable/store'
import { PaginationItem } from '@material-ui/lab'

const DatatablePagination = () => {
	const dispatch = useDispatch()
	const page = useSelector(datatableSelectors.getActualPage)
	const count = useSelector(datatableSelectors.getPagesCount)
	const show = useSelector(datatableSelectors.getShowPaginator)

	const handlePageChange = (_: ChangeEvent<any>, page: number) => {
		dispatch(datatableActions.updatePage({ page }))
		dispatch(datatableActions.getData())
	}

	if (!show) {
		return null
	}

	const isDirectionRtl = () => {
		return document.dir === 'rtl'
	}

	const customRtlRender = (item: PaginationRenderItemParams) => {
		const className = isDirectionRtl() && item.type !== 'page' ? 'rotate-180' : ''
		return <PaginationItem className={className} {...item} />
	}

	return <Pagination onChange={handlePageChange} page={page} count={count} renderItem={customRtlRender} />
}

export default DatatablePagination
